import { AggregatedByAndSubPlotValue, AggregatedByAndSubPlotLabel, SelectionPerAnnum } from 'utils';

export const CategorySpendSelectionUS = {
    perAnnum: [
        { label: SelectionPerAnnum.CUMULATIVE, value: SelectionPerAnnum.CUMULATIVE },
        { label: SelectionPerAnnum.PER_ANNUM, value: SelectionPerAnnum.PER_ANNUM },
    ],
    aggregatedBy: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
};

export const PopulationSelectionUS = {
    aggregatedBy: [
        {
            value: AggregatedByAndSubPlotValue.ALL_POPULATION,
            label: AggregatedByAndSubPlotLabel.TOTAL_POPULATION,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        {
            value: AggregatedByAndSubPlotValue.AGGREGATED,
            label: AggregatedByAndSubPlotLabel.COMBINED_MULTICULTURAL,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
};

export const DemographicSelectionUS = {
    aggregatedBy: [
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
};

export const BusinessSelectionUS = {
    perAnnum: [
        { label: SelectionPerAnnum.CUMULATIVE, value: SelectionPerAnnum.CUMULATIVE },
        { label: SelectionPerAnnum.PER_ANNUM, value: SelectionPerAnnum.PER_ANNUM },
    ],
    aggregatedBy: [
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.SOCIO_ECONOMIC,
            label: AggregatedByAndSubPlotLabel.SOCIOECONOMIC,
        },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.SOCIO_ECONOMIC,
            label: AggregatedByAndSubPlotLabel.SOCIOECONOMIC,
        },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
};

export const CurrentSpendSelection = {
    perAnnum: [
        { label: SelectionPerAnnum.CUMULATIVE, value: SelectionPerAnnum.CUMULATIVE },
        { label: SelectionPerAnnum.PER_ANNUM, value: SelectionPerAnnum.PER_ANNUM },
    ],
    aggregatedBy: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
};

export const DriversOfGrowthsSelectionUS = {
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        { value: AggregatedByAndSubPlotValue.DRIVER, label: AggregatedByAndSubPlotLabel.DRIVER },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    xAxis: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.GEO_NAME,
            label: AggregatedByAndSubPlotLabel.GEOGRAPHY,
        },
        { value: AggregatedByAndSubPlotValue.DRIVER, label: AggregatedByAndSubPlotLabel.DRIVER },
    ],
};

export const CategorySpendSelectionUK = {
    perAnnum: [
        { label: SelectionPerAnnum.CUMULATIVE, value: SelectionPerAnnum.CUMULATIVE },
        { label: SelectionPerAnnum.PER_ANNUM, value: SelectionPerAnnum.PER_ANNUM },
    ],
    aggregatedBy: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
};

export const PopulationSelectionUK = {
    aggregatedBy: [
        {
            value: AggregatedByAndSubPlotValue.ALL_POPULATION,
            label: AggregatedByAndSubPlotLabel.TOTAL_POPULATION,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        {
            value: AggregatedByAndSubPlotValue.AGGREGATED,
            label: AggregatedByAndSubPlotLabel.COMBINED_MULTICULTURAL,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    subPlot: [
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
};

export const DemographicSelectionUK = {
    aggregatedBy: [
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
};

export const BusinessSelectionUK = {
    perAnnum: [
        { label: SelectionPerAnnum.CUMULATIVE, value: SelectionPerAnnum.CUMULATIVE },
        { label: SelectionPerAnnum.PER_ANNUM, value: SelectionPerAnnum.PER_ANNUM },
    ],
    aggregatedBy: [
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.SOCIO_ECONOMIC,
            label: AggregatedByAndSubPlotLabel.SOCIOECONOMIC,
        },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        {
            value: AggregatedByAndSubPlotValue.SOCIO_ECONOMIC,
            label: AggregatedByAndSubPlotLabel.SOCIOECONOMIC,
        },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
};

export const DriversOfGrowthsSelectionUK = {
    subPlot: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        { value: AggregatedByAndSubPlotValue.DRIVER, label: AggregatedByAndSubPlotLabel.DRIVER },
        {
            value: AggregatedByAndSubPlotValue.NONE,
            label: AggregatedByAndSubPlotLabel.NO_AGGREGATION,
        },
    ],
    xAxis: [
        {
            value: AggregatedByAndSubPlotValue.SUBCATEGORY,
            label: AggregatedByAndSubPlotLabel.SUBCATEGORIES,
        },
        {
            value: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
            label: AggregatedByAndSubPlotLabel.ETHNIC_GROUP,
        },
        { value: AggregatedByAndSubPlotValue.AGE_GROUP, label: AggregatedByAndSubPlotLabel.AGE },
        { value: AggregatedByAndSubPlotValue.SEX, label: AggregatedByAndSubPlotLabel.SEX },
        {
            value: AggregatedByAndSubPlotValue.INCOME_BRACKET,
            label: AggregatedByAndSubPlotLabel.DISPOSABLE_INCOME,
        },
        { value: AggregatedByAndSubPlotValue.DRIVER, label: AggregatedByAndSubPlotLabel.DRIVER },
    ],
};
